import ProfileDetail from "./profile-details";

export default ProfileDetail